import { useState } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import PoServies from "../../../services/PoServices";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";

const PoReport = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [totalcount, setTotalCount] = useState(0);

  // Fetch PO + Items
  const fetchReport = async () => {
    setLoading(true);

    try {
      const response = await PoServies.AllPOItemsByStatus(status);

      const poList = response?.data || [];
      console.log("polist", poList)

      // Flatten PO -> Item rows
      const flattened = poList.flatMap((po) =>
        po.items.map((item) => ({
          ...item,
          poNumber: po.poNumber,
          poId: po.poId,
          poStatus: po.status,
        }))
      );

      setReportData(flattened);
      setTotalCount(flattened.length);

      Swal.fire({
        icon: "success",
        title: "Report Generated",
        text: `Report successfully generated for status: ${status}`,
      });
    } catch (error) {
      setReportData([]);
      setTotalCount(0);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch report data.",
      });
    } finally {
      setLoading(false);
    }
  };

  // Search only PO Number + Requisition No
  const filteredData = reportData.filter((item) => {
    const q = searchQuery.toLowerCase();

    const poNum = String(item?.poNumber || "").toLowerCase();
    const reqNo = String(item?.requisitionNo?.requisitionNo || "").toLowerCase();

    return poNum.includes(q) || reqNo.includes(q);
  });

  const totalReceivedQty = filteredData.reduce(
    (sum, item) => sum + Number(item?.qtyRecived || 0),
    0
  );

  // Download Excel
  const downloadExcel = () => {
    if (filteredData.length === 0) {
      Swal.fire({
        icon: "info",
        title: "No Data",
        text: "No data available to download.",
      });
      return;
    }

    const formatted = filteredData.map((item, index) => ({
      "S.No": index + 1,
      "PO Number": item?.poNumber,
      "Requisition No": item?.requisitionNo?.requisitionNo,
      "Requisition Date": item?.requisitionNo?.createdAt?.split("T")[0],
      "Part No": item?.inventory?.masterItem?.partNo,
      "Description": item?.inventory?.masterItem?.description,
      "Unit": item?.inventory?.masterItem?.unit?.name,
      "Required Qty": item?.qtyRequired,
      "Approved Qty": item?.approveQty,
      "Received Qty": item?.qtyRecived,
      "Status": item?.status === "approved" ? "Order Pending" : item?.status,
      "MRV No": item?.mrv?.mrvNo,
      "Supplier": item?.mrv?.supplier?.name || "NA",
      "Received Date": item?.updatedAt?.split("T")[0],
      "Admin Remark": item?.adminRemark,
    }));

    const fileName = `PO_Report_${status}_${new Date().toISOString().split("T")[0]}.xlsx`;

    const sheet = XLSX.utils.json_to_sheet(formatted);
    const book = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(book, sheet, "PO Report");

    XLSX.writeFile(book, fileName);
  };

  const Loader = () => (
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      style={{ height: "300px", width: "100%" }}
    >
      <div
        className="spinner-border text-primary"
        role="status"
        style={{ width: "3rem", height: "3rem" }}
      >
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="mt-3 text-primary fw-semibold">PO Deatils Loading...</p>
    </div>
  );


  return (
    <>
      <div className="col-xl-12">

        {/* FILTER SECTION */}
        <div className="filter cm-content-box box-primary">
          <div className="content-title">
            <div className="cpa">
              <i className="fas fa-filter me-2"></i>Filter
            </div>

            <div className="tools">
              <Link
                to={"#"}
                className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                onClick={() => setOpen(!open)}
              >
                <i className="fas fa-angle-up"></i>
              </Link>
            </div>
          </div>

          <Collapse in={open}>
            <div className="cm-content-body form excerpt">
              <div className="card-body">

                <div className="row">

                  {/* STATUS DROPDOWN */}
                  <div className="col-xl-4">
                    <label className="ms-2">PO Status</label>
                    <select
                      className="form-select"
                      value={status}
                      style={{ height: "55px" }}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <option value="">-- Select Status --</option>

                      <option value="Bill-Generated">Bill-Generated</option>
                      <option value="Order-Received">Order-Received</option>
                      <option value="Partially-Received">Partially-Received</option>
                      <option value="Confirmed-Generated">Printable PO</option>
                      <option value="PaymentPending">Payment Pending</option>
                      <option value="Completed">Completed</option>



                    </select>
                  </div>

                  {/* GENERATE REPORT BUTTON */}
                  <div className="col-xl-4">
                    <label className="ms-2">Generate</label>
                    <button
                      className="form-control btn btn-primary"
                      onClick={fetchReport}
                      disabled={loading}
                    >
                      {loading ? "Loading..." : "Generate Report"}
                    </button>
                  </div>

                  {/* DOWNLOAD EXCEL BUTTON (Activated after data load) */}
                  <div className="col-xl-4">
                    <label className="ms-2">Download</label>
                    <button
                      className="btn btn-success w-100"
                      disabled={reportData.length === 0}
                      onClick={downloadExcel}
                    >
                      Download Excel
                    </button>


                  </div>

                </div>

              </div>
            </div>
          </Collapse>
        </div>

        {/* TABLE SECTION */}
        <div className="filter cm-content-box box-primary">
          <div className="content-title">
            <div className="cpa">
              <i className="fa fa-list me-2"></i>PO Report
              <span className="badge bg-orange ms-2">{totalcount}</span>
            </div>

            <div className="tools">
              <Link
                to={"#"}
                className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                onClick={() => setOpen2(!open2)}
              >
                <i className="fas fa-angle-up"></i>
              </Link>
            </div>
          </div>

          <Collapse in={open2}>
            <div className="cm-content-body form excerpt">
              <div className="card-body">

                {/* SEARCH */}
                {reportData.length > 0 && (
                  <div className="row mb-2">
                    <div className="col-12 d-flex justify-content-center gap-3">
                      <input
                        className="form-control"
                        style={{ width: "500px" }}
                        placeholder="Search by PO Number / Requisition No"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </div>
                  </div>
                )}

                {/* TABLE */}
                <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>PO No.</th>
                        <th>Requisition No</th>
                        <th>Date</th>
                        <th>Part No</th>
                        <th>Description</th>
                        <th>Unit</th>
                        <th>Required Qty</th>
                        <th>Approved Qty</th>
                        <th>Received Qty</th>
                        <th>Status</th>
                        <th>MRV No</th>
                        <th>Supplier</th>
                        <th>Received Date</th>
                        <th>Reason</th>
                      </tr>
                    </thead>

                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="20">
                            <Loader />
                          </td>
                        </tr>
                      ) : filteredData.length > 0 ? (
                        <>
                          {filteredData.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item?.poNumber}</td>
                              <td>{item?.requisitionNo?.requisitionNo}</td>
                              <td>{item?.requisitionNo?.createdAt?.split("T")[0]}</td>
                              <td>{item?.inventory?.masterItem?.partNo}</td>
                              <td className="scrollable-description">
                                {item?.inventory?.masterItem?.description}
                              </td>
                              <td>{item?.inventory?.masterItem?.unit?.name}</td>
                              <td>{item?.qtyRequired}</td>
                              <td>{item?.approveQty}</td>
                              <td>{item?.qtyRecived}</td>
                              <td>{item?.status === "approved" ? "Order Pending" : item?.status}</td>
                              <td>{item?.mrv?.mrvNo}</td>
                              <td>{item?.mrv?.supplier?.name || "NA"}</td>
                              <td>{item?.updatedAt?.split("T")[0]}</td>
                              <td>{item?.adminRemark}</td>
                            </tr>
                          ))}

                          {/* TOTAL ROW */}
                          <tr>
                            <td colSpan="9" className="text-end">
                              <strong>Total Received Qty:</strong>
                            </td>
                            <td colSpan="6">
                              <strong>{totalReceivedQty}</strong>
                            </td>
                          </tr>
                        </>
                      ) : (
                        <tr>
                          <td colSpan="20" className="text-center">
                            No data available.
                          </td>
                        </tr>
                      )}
                    </tbody>

                  </table>
                </div>

              </div>
            </div>
          </Collapse>

        </div>
      </div>
    </>
  );
};

export default PoReport;
